const fontsConfig = [];

export default fontsConfig;
